import { IApiLogs } from "@/types/common";
import BaseTable, { BaseTableColumn } from "@/components/tables/BaseTable";

const SettingsLogsTable = ({ 
  apiLogs,
  pagination,
  setPagination,
  totalCount,
  loading,
}: { 
  apiLogs: IApiLogs[];
  pagination: { page: number; limit: number; };
  setPagination: (pagination: { page: number; limit: number ;}) => void;
  totalCount: number;
  loading: boolean;
}) => {
  const COLUMNS_TO_RENDER: BaseTableColumn[] = [
    "dateTime",
    "documentName",
    "request",
    "response",
    "apiStatus",
  ];

  return (
    <BaseTable 
      data={apiLogs} 
      columns={COLUMNS_TO_RENDER}
      pagination={pagination}
      setPagination={setPagination}
      totalCount={totalCount}
      loading={loading}
    />
  );
};
export default SettingsLogsTable;
